export default __webpack_public_path__ + "static/saas-business-for-global-shifts-interactive-quiz-f0addffe281b30054e550b67426004da.png";